// @ is an alias to /src

export default {
  name: 'LeftLayout',
  components: { 
    
  },
  data: () => ({
  }),
}